<template>
  <div
    class="fixed bottom-0 left-0 right-0 border-t border-gray-200 shadow bg-gray-100 py-1 px-4 flex gap-4 items-center text-xs"
  >
    <div v-if="layout === LAYOUT.INSIDESECTION">
      Press
      <kbd>esc</kbd>
      to exit the section,
      <kbd>delete</kbd>
      to delete selected items,
      <kbd>Ctrl-A</kbd>
      to select all,
      <kbd>Ctrl-C</kbd>
      ,
      <kbd>Ctrl-V</kbd>
      to copy and paste
    </div>
    <div v-else-if="drawingMode === DRAWINGMODE.SECTION.PATH">
      <kbd>Click</kbd>
      to add a node,
      <kbd>click + drag</kbd>
      to change curvature. Hold
      <kbd>shift</kbd>
      to only move one handle.
      <kbd>Right click</kbd>
      to delete the last node. Close the path by clicking the first node
    </div>
    <div v-else-if="splitModeUnit">
      Select a section shape and sketch as many sections as necessary to split this section. Ensure that each seat is
      assigned a section.
    </div>
    <div v-else-if="resizedUnit">
      Press
      <kbd>esc</kbd>
      to cancel resizing, press
      <kbd>enter</kbd>
      to confirm.
      <template v-if="resizedUnitIsPath">
        Use
        <kbd>shift</kbd>
        to move one handle freely.
      </template>
    </div>
    <div v-else>
      Press
      <kbd>esc</kbd>
      to clear selection, hold down
      <kbd>shift</kbd>
      to reveal contents,
      <kbd>delete</kbd>
      to delete selected sections,
      <kbd>Ctrl-A</kbd>
      to select all
    </div>
    <div v-if="selectedUnits.length > 0" class="w-px self-stretch bg-gray-400" />
    <div v-if="selectedUnits.length > 0">
      <strong>{{ selectedUnits.length - invisibleSelectedSeats.length }}</strong>
      selected
      {{ invisibleSeats > 0 ? `(${selectedUnits.length} total)` : '' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { LAYOUT, TYPE, DRAWINGMODE } from '@/constants';
import { Unit } from '@/core/models';
import Selection from '@/core/models/selection';
import { useState } from '@/store/useStore';
import eventbus from 'tiny-emitter/instance';
import { computed, onBeforeUnmount, ref, shallowRef } from 'vue';
import Application from '@/core/application';

const app = Application.instance;

const { tablesCount, tableSeats, gaCount, gaSeats, blockedSeats, blockedGa, invisibleSeats } = useState('stats');
const { splitModeUnit, resizedUnit } = useState('seatmap');
const { layout, drawingMode } = useState('settings');

const collapsed = ref(false);
const selectedUnits = shallowRef<Unit[]>([]);
const totalZones = ref(0);

const invisibleSelectedSeats = computed(() => {
  return selectedUnits.value.filter((seat) => seat.attributes.invisible == true);
});

const resizedUnitIsPath = computed(() => {
  const section = app.seatmap.getSectionById(resizedUnit.value!);
  return section && section.subtype === TYPE.PATH;
});

function onSelectionUpdate(selection: Selection) {
  selectedUnits.value = selection.items;
}

eventbus.on('selection:updated', onSelectionUpdate);

onBeforeUnmount(() => {
  eventbus.off('selection:updated', onSelectionUpdate);
});
</script>
